
import React, { useState, useEffect, useImperativeHandle, forwardRef } from 'react';
const Wompi = forwardRef((props, ref) => {
    useEffect(() => {
        // Crear y añadir el script de Wompi al DOM
        const script = document.createElement('script');
        script.src = "https://checkout.wompi.co/widget.js";
        script.dataset.render = "button";
        script.dataset.publicKey = props.pub_test;
        script.dataset.currency = props.price.currency.code;
        script.dataset.amountInCents = props.prices.wompi;
        script.dataset.reference = props.reference;
        script.dataset.redirectUrl = `${props.return_url}?affiliate_id=${props.customerData.affiliate_id}&discount_code_id=${props.customerData.discount_code_id}&price_id=${props.customerData.price_id}&user_platform_id=${props.customerData.user_platform_id}&status=success`;
        script.dataset.taxInCentsConsumption = "590000";
        script.dataset.taxInCentsVat = "1290000";
        // Agregar campos personalizados en data-extra-data
        //script.dataset.reference = props.customerData;
        script.setAttribute(
            "data-signature:integrity",
            `${props.cadena}`
        );
        document.getElementById('wompi-form').appendChild(script);
    
        // Limpiar el script al desmontar el componente
        return () => {
            document.getElementById('wompi-form').innerHTML = '';
        };
    }, []);

    return (
        <React.Fragment>        
            <form id="wompi-form"></form>
        </React.Fragment>
    );
});


export default Wompi;